export default (stateGlobalEvents = {}, action) => {
  switch (action.type) {
    case 'CHANGE_PROFILE':
      return {
        ...stateGlobalEvents,
        profileData: action.payload.profileData
      }
    case 'CHANGE_FAVOURITE':
      return {
        ...stateGlobalEvents,
        favouriteData: action.payload.favouriteData
      }
    case 'HOME_ARTICLE_UPDATE':
      return {
        ...stateGlobalEvents,
        homeArticle: action.payload.homeArticle
      }
    case 'DARK_MODE':
      return {
        ...stateGlobalEvents,
        darkModeEna: action.payload.darkModeEna
      }
    default:
      return stateGlobalEvents
  }
}
